import { useEffect, useState } from 'react';
import css from './Sections.module.css';
import { Tabs, Button, List, Collapse, Space } from 'antd';
import {
  SmileOutlined,
  DesktopOutlined,
  BlockOutlined,
  UsergroupAddOutlined,
  CheckCircleOutlined,
  FileSearchOutlined,
  PicCenterOutlined,
  FieldTimeOutlined,
  UserOutlined,
  EditOutlined,
  UserSwitchOutlined,
  SwapOutlined,
  LikeOutlined,
  ShrinkOutlined,
  AimOutlined,
  ApartmentOutlined,
  DollarOutlined,
  ScanOutlined,
  TeamOutlined,
  IssuesCloseOutlined,
  BankOutlined,
  ColumnWidthOutlined,
  ZoomInOutlined,
  GoldOutlined,
  SafetyOutlined,
  ScheduleOutlined,
  MehOutlined,
  SyncOutlined,
  SafetyCertificateOutlined,
  DeleteColumnOutlined,
  ReloadOutlined,
  LockOutlined,
  TagOutlined,
  UngroupOutlined,
  DeploymentUnitOutlined,
  OneToOneOutlined,
  PartitionOutlined,
  MergeOutlined,
  FileProtectOutlined,
  InteractionOutlined,
  MonitorOutlined,
  LinkOutlined,
  SecurityScanOutlined,
  SelectOutlined,
  CheckOutlined,
  FilterOutlined
} from '@ant-design/icons';
import TalentImg from '../../../../assets/talent.png';
import WorkImg from '../../../../assets/work.png';
import PartnersImg from '../../../../assets/partners.png';
import RPFsImg from '../../../../assets/rfps.png';
import { createResourceLocatorString } from "../../../../util/routes";
import { Link, useLocation } from 'react-router-dom';
import { parse } from '../../../../util/urlHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSectionsData } from '../../../../ducks/strapi.duck';

const data1 = [
  {
    title: 'Pre-Verified IT Talent Pool',
    icon: <CheckCircleOutlined />,
    description: 'Access a curated pool of IT professionals with verified skills, experience, and credentials—ready to engage from day one.',
  },
  {
    title: 'Upfront Identity and Experience Checks',
    icon: <ScheduleOutlined />,
    description: 'Ability to mandate verficiation of candidate identity, work auth or experience before enagaging with them in your sourcing pipelines.',
  },
  {
    title: 'Fraud-Free Candidate Submissions',
    icon: <MehOutlined />,
    description: 'Eliminate fake profiles, ghost applicants, and staffing misrepresentation with verified submissions only.',
  },
  {
    title: 'Reusable Credentials, Lower Hiring Costs',
    icon: <SyncOutlined />,
    description: 'Candidates carry verified credentials that reduce repeat screenings and lower total hiring costs.',
  },
  {
    title: 'Faster, More Transparent Hiring',
    icon: <FieldTimeOutlined />,
    description: 'Streamlined tools and verified data enable faster decisions and higher-quality hires.',
  },
];

const data2 = [
  {
    title: 'Earn More with Verification',
    icon: <SafetyCertificateOutlined />,
    description: 'Verified candidates earn more by signaling trust and credibility to high-value employers from the start.',
    // description: 'iParley enables you to differentiate yourself from fraudulent profiles and partner with reputable employers who value your skills and expertise, ensuring you engage with credible organizations. Our platform provides access to a wide range of reliable job opportunities across various industries and roles, tailored to match your unique skill set. With our intelligent matching system, you will connect with jobs that align perfectly with your qualifications and career goals. Additionally, our user-friendly interface simplifies the application process, allowing you to easily apply for jobs, track your applications, and communicate with potential employers.',
  },
  {
    title: 'Stand Out from Fake Profiles',
    icon: <DeleteColumnOutlined />,
    description: "Differentiate yourself in a crowded market by showing verified credentials that prove you're real.",
  },
  // {
  //   title: 'Earn More with Verification',
  //   icon: <CheckCircleOutlined />,
  //   description: 'Verified candidates earn more by signaling trust and credibility to high-value employers from the start.',
  // },
  {
    title: 'Control PII with Credentials',
    icon: <LockOutlined />,
    description: 'Keep your sensitive personal data secure and private with encrypted, self-controlled credentials. Control what PII data and how its shared with recruiters while doing new contract search.',
  },
  {
    title: 'Reusable Credentials, Owned by You',
    icon: <ReloadOutlined />,
    description: 'VApply faster using self-owned, reusable credentials that eliminate repeated verifications.',
  },
  {
    title: 'Restore Trust in IT Contigent Hiring',
    icon: <LikeOutlined />,
    description: 'Be part of a hiring process built on transparency, quality, and verified credentials.',
  },
];

const data3 = [
  {
    title: 'Verified, Enterprise-Ready Supplier Profiles',
    icon: <SafetyOutlined />,
    description: 'Engage only with vetted implementation firms ready for enterprise delivery from day one.',
  },
  {
    title: 'Transparent, Competitive Supplier Pricing',
    icon: <TagOutlined />,
    description: 'Compare real proposals and pricing to make informed, value-based decisions.',
  },
  {
    title: 'Smart Matching by Project Needs',
    icon: <UngroupOutlined />,
    description: 'Get matched to suppliers based on scope, skill, and compliance requirements.',
  },
  {
    title: 'Streamlined End-to-End RFP Tools',
    icon: <ColumnWidthOutlined />,
    description: 'Issue, manage, and compare RFPs in one unified platform.',
  },
  {
    title: 'Equal Access to Emerging and big suppliers',
    icon: <DeploymentUnitOutlined />,
    description: 'Discover new, qualified firms—beyond static supplier lists or incumbent bias.',
  },
  // {
  //   title: 'Comprehensive Partner Showcase',
  //   icon: <TeamOutlined />,
  //   description: 'Implementation partners can create detailed profiles, showcasing their expertise, certifications, and past project successes. This visibility helps clients make informed decisions based on transparent information.',
  // },
  // {
  //   title: 'Issue RFPs with Ease',
  //   icon: <IssuesCloseOutlined />,
  //   description: 'Our platform allows partners to issue and manage RFPs seamlessly. This ensures that partners can reach a wide audience of potential clients who are actively seeking their services.',
  // },
  // {
  //   title: 'Transparent Pricing and Cost Efficiency',
  //   icon: <CheckCircleOutlined />,
  //   description: 'By using iParley, companies are not limited to vendors recommended by software tool providers. This creates transparency in pricing and enables more cost-efficient choices.',
  // },
  // {
  //   title: 'Verified Expertise',
  //   icon: <CheckCircleOutlined />,
  //   description: 'Our platform features only verified partners with proven track records, ensuring that you collaborate with experts who deliver results.',
  // },
  // {
  //   title: 'Diverse Specializations',
  //   icon: <CheckCircleOutlined />,
  //   description: 'Find partners with expertise in various domains and industries, including IT, business process management, software development, and more.',
  // },
  // {
  //   title: 'Tailored Matching',
  //   icon: <CheckCircleOutlined />,
  //   description: 'Our intelligent matching system connects you with implementation partners whose skills and experience align with your specific project needs.',
  // },
  // {
  //   title: 'Efficient Collaboration',
  //   icon: <CheckCircleOutlined />,
  //   description: 'Our platform facilitates seamless communication and collaboration, making it easy to manage your projects and achieve your goals. ',
  // },
  // {
  //   title: 'Quality Assurance ',
  //   icon: <CheckCircleOutlined />,
  //   description: 'We ensure all our partners meet stringent quality standards, so you can trust them to provide high-quality services and solutions.',
  // },
];

const data4 = [
  {
    title: 'Verified RFPs from Real Buyers',
    icon: <CheckCircleOutlined />,
    description: 'Access active RFPs from verified enterprise clients—not vague listings or speculative leads.',
  },
  {
    title: 'Tailored Matching to Capabilities',
    icon: <OneToOneOutlined />,
    description: 'Get matched with RFPs aligned to your firm’s technical expertise, certifications, and scope.',
  },
  {
    title: 'Streamlined RFP Response Workflow',
    icon: <PartitionOutlined />,
    description: 'Manage proposals, deadlines, and collaboration—all in one place. High-Quality, Scoped Project Listings: Work only on serious, well-defined projects—not speculative or under-scoped opportunities.',
  },
  {
    title: 'Cross-Industry Enterprise Project Access',
    icon: <MergeOutlined />,
    description: 'Access IT project RFPs across industries like finance, healthcare, tech, and government.',
  },
  // {
  //   title: 'Efficient Management',
  //   icon: <GoldOutlined />,
  //   description: 'Use our platform to manage your proposals, track deadlines, and communicate with potential clients, streamlining the entire RFP process.',
  // },
  // {
  //   title: 'Quality Assurance',
  //   icon: <SafetyOutlined />,
  //   description: 'We ensure that all RFPs on our platform meet high standards of quality and relevance, so you can focus on projects that truly matter.',
  // },
];

const onChange = key => {
  console.log(key);
};

const Infographics1 = (extraSection) => {

  // Define all icons in an array
  const icons = [
    <EditOutlined />,
    <UserSwitchOutlined />,
    <FileProtectOutlined />,
    <UsergroupAddOutlined />,
    <InteractionOutlined />,
    <LikeOutlined />,
  ];

  // Extract the data array from extraSection
  const data = extraSection?.extraSection?.data || [];
  const heading = extraSection?.extraSection?.heading?.toLowerCase() === 'talent how it works' ? 'How it works' : 'How It works';

  return (
    <>
      <h3>{heading}</h3>
      <div className={css.infographics}>
        {data.map((item, index) => {
          const icon = icons[index % icons.length];

          return (
            <div key={item.id} className={css.infoList}>
              <div className={css.infoIcon}>
                {icon}
              </div>
              <div className={css.infoCotent}>
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

const Infographics2 = (extraSection) => {

  // Define all icons in an array
  const icons = [
    <EditOutlined />,
    <DeleteColumnOutlined />,
    <ReloadOutlined />,
    <MonitorOutlined />,
    <LikeOutlined />,
    <LinkOutlined />,
  ];

  // Extract the data array from extraSection
  const data = extraSection?.extraSection?.data || [];
  const heading = extraSection?.extraSection?.heading?.toLowerCase() === 'work how it works' ? 'How it works' : 'How It Works';

  return (
    <>
      <h3>{heading}</h3>
      <div className={css.infographics}>
        {data.map((item, index) => {
          const icon = icons[index % icons.length];

          return (
            <div key={item.id} className={css.infoList}>
              <div className={css.infoIcon}>
                {icon}
              </div>
              <div className={css.infoCotent}>
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

const Infographics3 = (extraSection) => {

  // Define all icons in an array
  const icons = [
    <EditOutlined />,
    <SecurityScanOutlined />,
    <SelectOutlined />,
    <SwapOutlined />,
    <CheckOutlined />,
    <LikeOutlined />,
  ];

  // Extract the data array from extraSection
  const data = extraSection?.extraSection?.data || [];
  const heading = extraSection?.extraSection?.heading?.toLowerCase() === 'partners how it works' ? 'How it works' : 'How It Works';

  return (
    <>
      <h3>{heading}</h3>
      <div className={css.infographics}>
        {data.map((item, index) => {
          const icon = icons[index % icons.length];

          return (
            <div key={item.id} className={css.infoList}>
              <div className={css.infoIcon}>
                {icon}
              </div>
              <div className={css.infoCotent}>
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

const Infographics4 = (extraSection) => {

  // Define all icons in an array
  const icons = [
    <EditOutlined />,
    <SafetyOutlined />,
    <MonitorOutlined />,
    <FilterOutlined />,
    <OneToOneOutlined />,
    <MergeOutlined />,
  ];

  // Extract the data array from extraSection
  const data = extraSection?.extraSection?.data || [];
  const heading = extraSection?.extraSection?.heading?.toLowerCase() === 'rfps how it works' ? 'How it works' : 'How It Works';

  return (
    <>
      <h3>{heading}</h3>
      <div className={css.infographics}>
        {data.map((item, index) => {
          const icon = icons[index % icons.length];

          return (
            <div key={item.id} className={css.infoList}>
              <div className={css.infoIcon}>
                {icon}
              </div>
              <div className={css.infoCotent}>
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

const Talent = (props) => {
  const { redirectToSearchPage } = props;
  const currentLocation = useLocation();

  const search = parse(currentLocation.search);
  const dispatch = useDispatch();

  const sectionsData = useSelector(state => state.strapi?.sectionsData) || [];

  const section = sectionsData?.sections?.filter(sec => sec?.heading === 'Talent')[0] || {};
  const extraSection = sectionsData?.sections?.filter(sec => sec?.heading?.toLowerCase() === 'talent how it works')[0] || {};

  useEffect(() => {
    dispatch(fetchSectionsData());
  }, [dispatch, search?.tag]);

  const icons = [
    <CheckCircleOutlined />,
    <ScheduleOutlined />,
    <MehOutlined />,
    <SyncOutlined />,
    <FieldTimeOutlined />,
  ];

  // Extract dynamic data from section
  const dynamicData = section?.data?.map((item, index) => ({
    icon: icons[index % icons.length],
    title: item.title,
    description: item.text,
  })) || [];

  return (
    <div className={css.tabContent}>
      <div className={css.tabContentLeft}>
        <h3>{section?.heading || 'Talent'}</h3>
        <p>
          {section?.textBelowHeading || 'Welcome to iParley, your premier marketplace for verified staffing solutions. We specialize in connecting you with top-tier talent, meticulously vetted to meet the highest standards of professionalism and expertise. Whether you’re seeking candidates for short-term projects or long-term roles, our platform ensures you find the right fit effortlessly.'}
          <br />
          <br />
          <b>Why Choose iParley?</b>
        </p>
        <List
          itemLayout="horizontal"
          dataSource={dynamicData}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                avatar={item.icon}
                title={item.title}
                description={item.description}
              />
            </List.Item>
          )}
        />

        <Space>
          <Link to="more/talent">
            <Button>Learn More</Button>
          </Link>
          <Button type="primary" onClick={() => redirectToSearchPage('talent')}>Browse Talent</Button>
        </Space>
      </div>
      <div className={css.tabContentRight}>
        <Infographics1 extraSection={extraSection} />
      </div>
    </div>
  );
};

const Work = (props) => {
  const { redirectToSearchPage } = props;
  const currentLocation = useLocation();

  const search = parse(currentLocation.search);
  const dispatch = useDispatch();

  const sectionsData = useSelector(state => state.strapi?.sectionsData) || [];

  const section = sectionsData?.sections?.filter(sec => sec?.heading === 'Work')[0] || {};
  const extraSection = sectionsData?.sections?.filter(sec => sec?.heading?.toLowerCase() === 'work how it works')[0] || {};

  useEffect(() => {
    dispatch(fetchSectionsData());
  }, [dispatch, search?.tag]);

  const icons = [
    <SafetyCertificateOutlined />,
    <DeleteColumnOutlined />,
    <LockOutlined />,
    <ReloadOutlined />,
    <LikeOutlined />,
  ];

  // Extract dynamic data from section
  const dynamicData = section?.data?.map((item, index) => ({
    icon: icons[index % icons.length],
    title: item.title,
    description: item.text,
  })) || [];

  return (
    <div className={css.tabContent}>
      <div className={css.tabContentLeft}>
        <h3>{section?.heading || 'Talent'}</h3>
        <p>
          {section?.textBelowHeading || 'Welcome to iParley, where talented professionals connect with verified, meaningful opportunities that match their skills and career goals.'}
          <br />
          <br />
          <b>Why Choose iParley?</b>
        </p>
        <List
          itemLayout="horizontal"
          dataSource={dynamicData}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                avatar={item.icon}
                title={item.title}
                description={item.description}
              />
            </List.Item>
          )}
        />
        <Space>
          <Link to="more/work">
            <Button>Learn More</Button>
          </Link>
          <Button type="primary" onClick={() => redirectToSearchPage('work')}>Browse Work</Button>
        </Space>
      </div>
      <div className={css.tabContentRight}>
        <Infographics2 extraSection={extraSection} />
      </div>
    </div>
  );
};

const Partners = (props) => {
  const { redirectToSearchPage } = props;
  const currentLocation = useLocation();

  const search = parse(currentLocation.search);
  const dispatch = useDispatch();

  const sectionsData = useSelector(state => state.strapi?.sectionsData) || [];

  const section = sectionsData?.sections?.filter(sec => sec?.heading === 'Partners')[0] || {};
  const extraSection = sectionsData?.sections?.filter(sec => sec?.heading?.toLowerCase() === 'partners how it works')[0] || {};

  useEffect(() => {
    dispatch(fetchSectionsData());
  }, [dispatch, search?.tag]);

  const icons = [
    <SafetyOutlined />,
    <TagOutlined />,
    <UngroupOutlined />,
    <ColumnWidthOutlined />,
    <DeploymentUnitOutlined />,
  ];

  // Extract dynamic data from section
  const dynamicData = section?.data?.map((item, index) => ({
    icon: icons[index % icons.length],
    title: item.title,
    description: item.text,
  })) || [];

  return (
    <div className={css.tabContent}>
      <div className={css.tabContentLeft}>
        <h3>{section?.heading || 'Suppliers'}</h3>
        <p>
          {section?.textBelowHeading || 'Why Top Enterprise Procurement teams Choose iParley to Find Implementation Suppliers'}
        </p>
        <List
          itemLayout="horizontal"
          dataSource={dynamicData}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                avatar={item.icon}
                title={item.title}
                description={item.description}
              />
            </List.Item>
          )}
        />
        <Space>
          <Link to="more/partners">
            <Button>Learn More</Button>
          </Link>
          <Button type="primary" onClick={() => redirectToSearchPage('partners')}>Browse Suppliers</Button>
        </Space>
      </div>
      <div className={css.tabContentRight}>
        <Infographics3 extraSection={extraSection} />
      </div>
    </div>
  );
};

const RPFs = (props) => {
  const { redirectToSearchPage } = props;
  const currentLocation = useLocation();

  const search = parse(currentLocation.search);
  const dispatch = useDispatch();

  const sectionsData = useSelector(state => state.strapi?.sectionsData) || [];

  const section = sectionsData?.sections?.filter(sec => sec?.heading === 'RFPs')[0] || {};
  const extraSection = sectionsData?.sections?.filter(sec => sec?.heading?.toLowerCase() === 'rfps how it works')[0] || {};

  useEffect(() => {
    dispatch(fetchSectionsData());
  }, [dispatch, search?.tag]);

  const icons = [
    <CheckCircleOutlined />,
    <OneToOneOutlined />,
    <PartitionOutlined />,
    <MergeOutlined />,
  ];

  // Extract dynamic data from section
  const dynamicData = section?.data?.map((item, index) => ({
    icon: icons[index % icons.length],
    title: item.title,
    description: item.text,
  })) || [];

  return (
    <div className={css.tabContent}>
      <div className={css.tabContentLeft}>
        <h3>{section?.heading || 'RPFs'}</h3>
        <p>
          {section?.textBelowHeading || 'At iParley, we simplify how implementation suppliers discover new clients and projects offering verified opportunities matched to your verified capabilities and client requirements'}
        </p>
        <List
          itemLayout="horizontal"
          dataSource={dynamicData}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                avatar={item.icon} // Use `avatar` instead of `icon`
                title={item.title}
                description={item.description}
              />
            </List.Item>
          )}
        />
        <Space>
          <Link to="more/rfps">
            <Button>Learn More</Button>
          </Link>
          <Button type="primary" onClick={() => redirectToSearchPage('RFPS')}>Browse RFPs</Button>
        </Space>
      </div>
      <div className={css.tabContentRight}>
        <Infographics4 extraSection={extraSection} />
      </div>
    </div>
  );
};

function SectionWhy(props) {
  const { history, routeConfiguration } = props;

  const redirectToSearchPage = (listingTypeParam) => {
    history.push(
      createResourceLocatorString(
        'SearchPage',
        routeConfiguration,
        {},
        { listingType: listingTypeParam }
      )
    );
  };

  const hashToKey = {
    '#talent': '1',
    '#work': '2',
    '#partners': '3',
    '#rpfs': '4',
  };

  const keyToHash = {
    '1': '#talent',
    '2': '#work',
    '3': '#partners',
    '4': '#rpfs',
  };

  const items = [
    {
      key: '1',
      label: (
        <span>
          <img src={TalentImg} alt="Talent" width={40} />
          Finding Talent
        </span>
      ),
      children: <Talent redirectToSearchPage={redirectToSearchPage} />,
    },
    {
      key: '2',
      label: (
        <span>
          <img src={WorkImg} alt="Work" width={40} />
          Finding Work
        </span>
      ),
      children: <Work redirectToSearchPage={redirectToSearchPage} />,
    },
    {
      key: '3',
      label: (
        <span>
          <img src={PartnersImg} alt="Suppliers" width={40} />
          Finding Suppliers
        </span>
      ),
      children: <Partners redirectToSearchPage={redirectToSearchPage} />,
    },
    {
      key: '4',
      label: (
        <span>
          <img src={RPFsImg} alt="RFPs" width={40} />
          Finding RFPs
        </span>
      ),
      children: <RPFs redirectToSearchPage={redirectToSearchPage} />,
    },
  ];

  const [activeKey, setActiveKey] = useState('1');

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.toLowerCase();
      if (hashToKey[hash]) {
        setActiveKey(hashToKey[hash]);
        document.getElementById('whySection')?.scrollIntoView({ behavior: 'smooth' });
      }
    };

    // Call once on mount
    handleHashChange();

    // Listen for future changes
    window.addEventListener('hashchange', handleHashChange);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);


  const onChange = (key) => {
    setActiveKey(key);
    const hash = keyToHash[key];
    if (hash) {
      window.history.replaceState(null, '', hash);
    }
  };

  return (
    <div className={css.whySection} id="whySection">
      <div className={css.fixedWidthContainer}>
        <h2>Why iParley for..</h2>
        <div className={css.horizontalTab}>
          <Tabs
            activeKey={activeKey}
            onChange={onChange}
            items={items}
            className={css.inDesktop}
          />
          <Collapse
            activeKey={activeKey}
            onChange={onChange}
            items={items}
            className={css.inMobile}
          />
        </div>
      </div>
    </div>
  );
}


export default SectionWhy;
